import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Link from './Link';
import ShareButton from './ShareButton';
import LargeShareButton from './LargeShareButton';
import TwitterIcon from '../Svg/TwitterIconFooter';
import TwitterIcon2 from '../Svg/TwitterIcon';

import { actionShared } from '../../containers/Widget/actions';
import { copyFor } from '../../copy/copy';
import config from '../../config';

const getTwitterShareUrl = (
    url,
    publisherName,
    partnerName,
    isEmbed,
    widgetRequestId,
    isAltSharing,
    altSharingText,
    altSharingURL
) => {
    if (isAltSharing) url = altSharingURL || config['SHARE_URL'] + `?widgetId=${widgetRequestId}`;
    else if (isEmbed) url += `?widgetId=${widgetRequestId}`;

    const text =
        isAltSharing && altSharingText
            ? altSharingText + ' ' + url
            : partnerName !== undefined && partnerName !== 'Speakable'
            ? copyFor('sharing', 'twitterTextPartner', undefined, undefined, {
                  partnerName,
                  publisherName,
                  url
              })
            : publisherName === `@action`
            ? copyFor('sharing', 'twitterTextSpeakable', undefined, undefined, {
                  publisherName,
                  url
              })
            : copyFor('sharing', 'twitterTextNoPartner', undefined, undefined, {
                  publisherName,
                  url
              });
    return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
};

const TwitterShare = props => (
    <Link
        style={props.isAltSharing ? { textDecoration: 'none' } : null}
        href={getTwitterShareUrl(
            props.shareUrl,
            props.publisherName,
            props.partnerName,
            props.isEmbed,
            props.widgetRequestId,
            props.isAltSharing,
            props.altSharingText || props.altSharingDefaultText,
            props.altSharingURL
        )}
        target="_blank"
        onClick={() => props.actionShared('twitter')}
    >
        {props.isAltSharing ? (
            <LargeShareButton color="#00a1f9" marginRight="1rem" isShort={props.isShort}>
                <TwitterIcon2 width={21} height={17} viewBox="0 0 32 16" />
                {copyFor('sharing', 'largeTwitterShareButton' + (props.isMobileResolution ? 'Mobile' : ''))}
            </LargeShareButton>
        ) : (
            <ShareButton>
                <TwitterIcon />
            </ShareButton>
        )}
    </Link>
);

TwitterShare.propTypes = {
    actionShared: PropTypes.func.isRequired,
    isEmbed: PropTypes.bool.isRequired,
    partnerName: PropTypes.string,
    publisherName: PropTypes.string.isRequired,
    shareUrl: PropTypes.string.isRequired,
    widgetRequestId: PropTypes.string.isRequired,
    isAltSharing: PropTypes.bool,
    altSharingText: PropTypes.string,
    altSharingDefaultText: PropTypes.string,
    altSharingURL: PropTypes.string,
    isShort: PropTypes.bool
};

export default connect(
    (state, props) => {
        return {
            isEmbed: state.widget.articleUrl.includes('embed'),
            widgetRequestId: state.widget.widgetRequestId,
            shareUrl: state.widget.articleUrl,
            publisherName:
                state.widget.twitterMention !== undefined
                    ? '@' + state.widget.twitterMention
                    : state.widget.publisherName || 'Speakable',
            partnerName:
                state.widget.selectedPartner !== undefined
                    ? (state.widget.selectedPartner || {}).twitterMention !== undefined
                        ? '@' + state.widget.selectedPartner.twitterMention
                        : (state.widget.selectedPartner || {}).name !== undefined
                        ? (state.widget.selectedPartner || {}).name
                        : undefined
                    : undefined,
            altSharingText: props.altSharingCustomText || state.widget.activeAction.altSharingTwitterMessage,
            isMobileResolution: state.widget.isMobileResolution
        };
    },
    {
        actionShared
    }
)(TwitterShare);
